import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1 sm:gap-2">
      <Globe size={16} className="text-gray-600 hidden sm:block" />
      <div className="flex bg-gray-100 rounded-md sm:rounded-lg p-0.5 sm:p-1">
        <button
          onClick={() => changeLanguage('en')}
          className={`px-1.5 sm:px-3 py-1 rounded text-xs sm:text-sm font-medium transition-colors ${
            language === 'en'
              ? 'bg-primary-500 text-white shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          EN
        </button>
        <button
          onClick={() => changeLanguage('ar')}
          className={`px-1.5 sm:px-3 py-1 rounded text-xs sm:text-sm font-medium transition-colors ${
            language === 'ar'
              ? 'bg-primary-500 text-white shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          ع
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;